import React, { useState } from "react";
import { image_proof, view } from "../../assets/img";
import CloseIcon from "@mui/icons-material/Close";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import moment from "moment";
import ImagePopup from "../ImagePopup";

const SingleTable2 = ({ WorkCompleted, status }) => {
  const [popup, setPopup] = useState(false);
  const [proof, setProof] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  // const roles = [
  //   {
  //     id: "Admin",
  //     name: "midhun",
  //     description: "Full access to all features",
  //     serialNo: "12345",
  //     closeDateTime: "2025-10-14 10:30 AM",
  //     assignBy: "Robert",
  //     videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ", // your YouTube link here
  //     proof: [
  //       { img: image_proof },
  //       { img: image_proof },
  //       { img: image_proof },
  //       { img: image_proof },
  //     ],
  //   },
  // ];

  console.log("WorkCompleted", WorkCompleted);

  const handlePopup = () => {
    if (WorkCompleted?.proofs?.length > 0) {
      setPopup(true);
    }
  };

  return (
    <div className="role-table-container my-3 ">
      {showPopup && (
        <ImagePopup showPopup={showPopup} setShowPopup={setShowPopup} />
      )}
      <table className="role-table">
        <thead>
          <tr>
            <th>Role</th>
            <th>Name</th>
            <th>Description</th>
            <th>
              {status != 6 ? "Proof Uploaded" : "Close"} <br /> Date & Time
            </th>
            <th>Assign By</th>
            {status != 6 && <th>Proof</th>}
          </tr>
        </thead>
        <tbody>
          {/* {roles.map((role, index) => ( */}
          <tr>
            <td>
              {WorkCompleted?.assigned_to?.role == 1
                ? "Super Admin"
                : WorkCompleted?.assigned_to?.role == 2
                ? "Inventory"
                : WorkCompleted?.assigned_to?.role == 3
                ? "Technical"
                : WorkCompleted?.assigned_to?.role == 4
                ? "Regional Manager"
                : WorkCompleted?.assigned_to?.role == 5
                ? "Service Engineer"
                : "-"}
            </td>
            <td>{WorkCompleted?.assigned_to?.name || "-"}</td>
            <td>{WorkCompleted?.remarks || "-"}</td>
            <td>
              {WorkCompleted?.proofs?.length > 0
                ? moment(WorkCompleted?.updated_at).format(
                    "DD-MM-YYYY - hh:mm A "
                  )
                : "-"}
            </td>
            <td>{WorkCompleted?.assigned_by?.name || "-"}</td>
            {status != 6 && (
              <td>
                <div
                  onClick={handlePopup}
                  className="cust-btn"
                  style={{
                    opacity: WorkCompleted?.proofs?.length > 0 ? 1 : 0.3,
                  }}
                >
                  <img src={view} alt="View" className="editor-btn" />
                </div>
              </td>
            )}
          </tr>
        </tbody>
      </table>

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je">
              <p className="popup-close-btn" onClick={() => setPopup(false)}>
                <CloseIcon />
              </p>
            </div>
            <div className="video-section">
              <label
                style={{ color: "#323691", fontWeight: "bold" }}
                className="d-flex ac-js mb-2"
              >
                Video Proof
              </label>
              <div className="video-proof-box" style={{ cursor: "pointer" }}>
                {WorkCompleted?.proofs?.map((item) => {
                  return (
                    <div>
                      {item?.status == "Video" && (
                        <video
                          className="video-proof-box"
                          width="300"
                          height="200px"
                          controls
                          autoPlay={false}
                        >
                          <source src={item?.file_url} type="video/mp4" />
                        </video>
                      )}
                    </div>
                  );
                })}
                {!WorkCompleted?.proofs?.some(
                  (item) => item.status === "Video"
                ) && (
                  <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                    No Video proof Uploaded
                  </p>
                )}
              </div>
            </div>
            <div className="images-section my-3">
              <label
                className="d-flex ac-js "
                style={{
                  color: "#323691",
                  fontWeight: "bold",
                  marginTop: "10px",
                }}
              >
                Image Proof
              </label>
              <div className="d-flex ac-js gap-3">
                {WorkCompleted?.proofs?.map((item, ind) => {
                  return (
                    <div key={ind}>
                      {item?.status == "Image" && (
                        <div>
                          <img
                            role="button"
                            onClick={() => setShowPopup(item?.file_url)}
                            src={item?.file_url}
                            className="image_proof"
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
                {WorkCompleted?.proofs?.length == 0 && (
                  <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                    No Image proof Uploaded
                  </p>
                )}
              </div>
            </div>
            <label
              style={{ color: "#323691", fontWeight: "bold" }}
              className="d-flex ac-js mb-2"
            >
              Description
            </label>
            <textarea
              readOnly
              className="input-box"
              name=""
              value={
                WorkCompleted?.issue_desc ? WorkCompleted?.issue_desc : "-"
              }
              id=""
            ></textarea>
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleTable2;
